<template>
  <v-menu class="card-menu">
    <template v-slot:activator="{ props }">
      <v-btn
        icon="mdi-dots-vertical"
        class="query-field-actions-btn"
        size="small"
        variant="plain"
        v-bind="props"
      />
    </template>
    <v-list density="compact">
      <v-list-item
        @click="emit('toggle-filter')"
        :disabled="!!field.relatedEntityId"
      >
        <v-list-item-title>
          <v-icon class="mr-2" color="grey" icon="mdi-filter-variant" />
          {{ field.type === 'filter' ? 'Unmark Filter' : 'Mark as Filter' }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        @click="emit('toggle-computed')"
        :disabled="!!field.relatedEntityId"
      >
        <v-list-item-title>
          <v-icon class="mr-2" color="grey" icon="mdi-function-variant" />
          {{ field.computed ? 'Unmark Computed' : 'Mark as Computed' }}
        </v-list-item-title>
      </v-list-item>
      <select-entity
        v-if="!hideEntity"
        @onSelectEntity="(entity) => emit('select-entity', entity)"
      >
        <v-list-item>
          <v-list-item-title class="cursor-pointer">
            <v-icon class="mr-2" color="grey">mdi-database</v-icon> Select Entity
          </v-list-item-title>
        </v-list-item>
      </select-entity>
      <v-list-item @click="emit('delete')">
        <v-list-item-title>
          <v-icon class="mr-2" color="grey" icon="mdi-trash-can-outline" /> Delete
        </v-list-item-title>
      </v-list-item>
      <template v-if="!hideEntity">
        <v-divider></v-divider>
        <div class="d-flex justify-center pt-1">
          <toggle
            mandatory
            :value="field.cardinality || 'one-to-one'"
            :options="FIELD_CARDINALITY_OPTIONS"
            :disabled="!field.relatedEntityId"
            @update:modelValue="(cardinality) => emit('update:cardinality', cardinality)"
          />
        </div>
      </template>
    </v-list>
  </v-menu>
</template>

<script setup>
import SelectEntity from '@/components/SelectEntity.vue'
import Toggle from '@/components/Toggle.vue'
import { FIELD_CARDINALITY_OPTIONS } from '@/constants/schema'

const { field, hideEntity } = defineProps({
  field: { type: Object, required: true },
  hideEntity: { type: Boolean, default: false }
})

const emit = defineEmits([
  'toggle-filter',
  'toggle-computed',
  'select-entity',
  'delete',
  'update:cardinality'
])
</script>
